// extracted by mini-css-extract-plugin
export default {"container":"styles_container__40g2U","control":"styles_control__jNMI9","controlIndicator":"styles_controlIndicator__H99NW"};